import axios from "axios";
import authService from "./authService";
const getConfigs = async () => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/config/list`);
        const data = response.data;

        const configs = {};

        data.forEach(item => {
            if (item.key === 'workday' || item.key === 'lunchBreak') {
                configs[item.key] = JSON.parse(item.value);
            } else {
                configs[item.key] = item.value;
            }
        });

        return configs;
    } catch (error) {
        console.error('Error fetching configs:', error);
        return {};
    }
};

const saveConfigs = async (configs) => {
    try {
        configs = configs.map(config => {
            if (config.key === 'lunchBreak' || config.key === 'workday') {
                return { ...config, value: JSON.stringify(config.value) };
            }
            return config;
        });

        await axios.post(`${process.env.VUE_APP_API_URL}/edit/config`, {
            configs: configs
        }, {
            headers: {
                Authorization: `${authService.getToken()}`,
            },
        });
    } catch (error) {
        console.error('Error saving configs:', error);
        throw error;
    }
};



export default {
    getConfigs,
    saveConfigs,
};